
document.addEventListener("DOMContentLoaded", function () {
  // Timer Configuration
  const endDate = new Date("2025-06-29T23:59:59").getTime(); // Set your end date here

function updateTimer() {
    const now = new Date().getTime();
    const timeRemaining = endDate - now;

    if (timeRemaining > 0) {
        const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

        // Add leading zeros to single-digit numbers
        const formattedDays = String(days).padStart(2, '0');
        const formattedHours = String(hours).padStart(2, '0');
        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(seconds).padStart(2, '0');

        document.getElementById("countdown-timer-c").textContent = 
            `${formattedDays}d ${formattedHours}u ${formattedMinutes}m ${formattedSeconds}s`;
    } else {
        document.getElementById("countdown-timer-c").textContent = "Actie verlopen!";
    }
}
  updateTimer();
  setInterval(updateTimer, 1000);

  const slides = document.querySelectorAll(".announcement-slide-c");
  let currentIndex = 0;

  function showNextSlide() {
    const currentSlide = slides[currentIndex];
    currentSlide.classList.remove("active");
    currentSlide.classList.add("previous");

    currentIndex = (currentIndex + 1) % slides.length;
    const nextSlide = slides[currentIndex];
    nextSlide.classList.add("active");

    setTimeout(() => {
      currentSlide.classList.remove("previous");
    }, 500); 
  }

  setInterval(showNextSlide, 5000);
});
